// extracted by mini-css-extract-plugin
export default {"wrap":"App_wrap__K098x","wrapContent":"App_wrapContent__a2-6Y"};